<template>
    <div class="section pt-2">
        <div class="grq-hero">
            <div class="grq-hero-icon"><ion-icon name="document-text-outline"></ion-icon></div>
            <h3 class="grq-hero-title mal-text">വിസ്‌ഡം ഗൈഡ് അപേക്ഷകൾ</h3>
            <p class="grq-hero-desc mal-text">
                ഭാരവാഹി മാറ്റം, വകുപ്പ് മാറ്റം, മെമ്പർഷിപ്പ് സംബന്ധിച്ച കാര്യങ്ങൾക്കുള്ള അപേക്ഷകൾ ഇവിടെ നിന്ന് സമർപ്പിക്കാനും അവയുടെ സ്റ്റാറ്റസ് കാണാനും സാധിക്കും.
            </p>
        </div>
    </div>

    <div class="section mt-1">
        <router-link v-if="parseInt($route.params.sub_level) > 0" :to="newRequestPath" class="grq-option-card">
            <div class="grq-option-icon grq-option-icon--new"><ion-icon name="add-circle-outline"></ion-icon></div>
            <div class="grq-option-body">
                <div class="grq-option-title mal-text">പുതിയ അപേക്ഷ</div>
                <div class="grq-option-desc mal-text">ഭാരവാഹി / വകുപ്പ് / മെമ്പർഷിപ്പ് മാറ്റത്തിന് പുതിയ അപേക്ഷ അയക്കുക</div>
            </div>
            <ion-icon name="chevron-forward-outline" class="grq-option-chevron"></ion-icon>
        </router-link>

        <router-link :to="listPath" class="grq-option-card">
            <div class="grq-option-icon grq-option-icon--list"><ion-icon name="list-outline"></ion-icon></div>
            <div class="grq-option-body">
                <div class="grq-option-title mal-text">അപേക്ഷകൾ കാണുക</div>
                <div class="grq-option-desc mal-text">സമർപ്പിച്ച അപേക്ഷകളുടെ സ്റ്റാറ്റസ് കാണാനും ഫോർവേഡ് / അപ്രൂവ് ചെയ്യാനും</div>
            </div>
            <ion-icon name="chevron-forward-outline" class="grq-option-chevron"></ion-icon>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'RequestHome',
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        newRequestPath() {
            return '/org/' + this.$route.params.sub_level + '/' + this.$route.params.id + '/request';
        },
        listPath() {
            return '/org/' + this.$route.params.sub_level + '/' + this.$route.params.id + '/request-list';
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.$root.updateParent('Wisdom Guide Requests');
    },
};
</script>

<style scoped>
.grq-hero {
    background: #fff;
    border-radius: 14px;
    padding: 22px 18px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.grq-hero-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #eef2ff;
    color: #1a418c;
    font-size: 26px;
    margin-bottom: 10px;
}

.grq-hero-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #27173E;
    margin-bottom: 6px;
}

.grq-hero-desc {
    font-size: 0.85rem;
    color: #6c757d;
    line-height: 1.5;
    margin: 0;
}

.grq-option-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    margin-bottom: 10px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    text-decoration: none;
    transition: background-color 0.15s ease;
}

.grq-option-card:active {
    background: #f8f9fa;
}

.grq-option-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    font-size: 22px;
}

.grq-option-icon--new {
    background: #eef2ff;
    color: #1a418c;
}

.grq-option-icon--list {
    background: #f0fdf4;
    color: #12a85a;
}

.grq-option-body {
    flex: 1;
    min-width: 0;
}

.grq-option-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #27173E;
    margin-bottom: 2px;
}

.grq-option-desc {
    font-size: 0.78rem;
    color: #6c757d;
    line-height: 1.4;
}

.grq-option-chevron {
    flex-shrink: 0;
    font-size: 20px;
    color: #adb5bd;
}
</style>
